<template>
  <div id="printReport">
    <div class="row">
      <div class="col-sm-2">
        <img src="@/assets/template/images/logo.png" alt="Consyst" style="height: 60px" />
      </div>
      <div class="col-sm-10">
        <h3 class="text-center">Relatório de Comissão Analítica por Perfil</h3>
      </div>
    </div>
    <br />
    <div class="row">
      <div class="col-sm-12">
        <div class="panel panel-defaul">
          <div class="panel-body">
            <div class="row">
              <div class="col-md-3">
                <label>Administradora</label>
                <br />
                {{ (form.administrator_id == null || form.administrator_id == '') ? 'Todas' : administrator }}
              </div>
              <div class="col-md-3">
                <label>Equipe</label>
                <br />
                {{ form.team_id == null ? 'Todas' : team }}
              </div>
              <div class="col-md-3">
                <label>Filtrar por</label>
                <br />
                {{ date }}
              </div>
              <div class="col-md-3">
                <label>Intervalo</label>
                <br />
                {{ init_at | moment('DD/MM/YYYY') }} à {{ end_at | moment('DD/MM/YYYY') }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <br />
    <div
      class="table-dados"
      v-show="report.length > 0"
      v-for="iterator in report"
      :key="iterator.id"
    >
      <div id="conteudo" class="col-md-12">
        <div class="row" v-if="displayCommissionsPerAdministrator">
          <b>Administratora: {{ iterator.name }}</b>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="{panel: displayCommissionsPerAdministrator, 'panel-defaul': displayCommissionsPerAdministrator}">
              <div class="{'panel-body': displayCommissionsPerAdministrator}">
                <table-report
                  v-if="iterator.proposals.salesmans"
                  profile="salesman"
                  :items="iterator.proposals.salesmans"
                  :commissions="iterator.commissions"
                  :date_by="form.date_by"
                ></table-report>
                <table-report
                  v-if="iterator.proposals.supervisors"
                  profile="supervisor"
                  :items="iterator.proposals.supervisors"
                  :commissions="iterator.commissions"
                  :date_by="form.date_by"
                ></table-report>
                <table-report
                  v-if="iterator.proposals.managers"
                  profile="manager"
                  :items="iterator.proposals.managers"
                  :commissions="iterator.commissions"
                  :date_by="form.date_by"
                ></table-report>
                <table-report
                  v-if="iterator.proposals.after_sales"
                  profile="after_sale"
                  :items="iterator.proposals.after_sales"
                  :commissions="iterator.commissions"
                  :date_by="form.date_by"
                ></table-report>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <resume v-show="report.length > 0 && (displayCommissionsPerAdministrator || form.salesman_id == null)" />

    <table id="my-table"></table>

    <div class="row dont-print">
      <div class="col-md-12 text-center">
        <button type="button" @click="close()" class="btn btn-fill btn-danger">Voltar</button>
        <button type="button" @click="print()" class="btn btn-fill btn-info">Imprimir</button>
        <button type="button" @click="pdf()" class="btn btn-fill btn-info">PDF</button>
        <!--button type="button" @click="excel()" class="btn btn-fill btn-success">Excel</button-->
      </div>
    </div>
    <div id="pdf"></div>
  </div>
</template>
<script>
import tableReport from "@/components/elements/TableReportAnalyticalCommissionProfile";
import resume from "@/views/Reports/AnalyticalCommissionByProfiles/Resume";
import Vue from 'vue'
import ExtraRewards from '@/services/modules/extra_rewards.service';

export default {
  components: {
    tableReport,
    resume
  },
  computed: {
    administrators: {
      get() {
        return this.$store.state.administrators.itens;
      }
    },
    displayCommissionsPerAdministrator: function () {
        return Boolean(this.$store.state.configurations.model.display_commissions_totals_only_on_analytical_commission_by_profile_report) == false;
    },
    dates: {
      get() {
        var dates = [
          { id: "sale_at", name: "Data de Venda" },
          { id: "deployment_at", name: "Data Alocação" },
          { id: "pay_at", name: "Data de Pagamento" },
          { id: "pay_at-sale_at", name: "Data de Pagamento (volume por data da venda)" },
          { id: 'pay_at-sale_at_interval', name: 'Data de Pagamento (volume no intervalo filtrado)' },
          { id: "due_at", name: "Data de Vencimento (apenas parcelas pagas)" },
          { id: "due_at-all", name: "Data de Vencimento (parcelas pagas e não pagas)" }
        ];

        return dates;
      }
    },
    profiles: {
      get() {
        if (this.form.type_profile_id !== undefined) {
          return this.form.type_profile_id;
        }
        return [];
      }
    },
    report: {
      get() {
        return this.$store.state.reports.item;
      }
    },
    teams: {
      get() {
        return this.$store.state.teams.itens;
      }
    }
  },
  data() {
    return {
      administrator: null,
      date: null,
      end_at: null,
      form: {},
      init_at: null,
      team: null,
      extra_rewards: null,
    };
  },
  methods: {
    hasExtraReward(items) {
        for (let i=0; i<items.length; i++) {
            if (this.getExtraRewardAmount(
                items[i].profile == 'supervisor'
                ? items[i].supervisorId
                : items[i].salesmanId
              ) > 0) {
                return true;
            }
        }
        return false;
    },
    getExtraReward(salesmanId) {
        for (let i=0; i<this.extra_rewards.length; i++) {
            if (this.extra_rewards[i].salesman_id == salesmanId) {
                return this.extra_rewards[i];
            }
        }
    },
    getExtraRewardAmount(salesmanId, which) {
        const extraReward = this.getExtraReward(salesmanId);
        if (extraReward) {
            if (which) {
              if (which == 1) {
                return extraReward.reward_amount;
              }
              return extraReward[`reward_amount_${which}`] * 1;
            }
            return (
              extraReward.reward_amount * 1 +
              extraReward.reward_amount_2 * 1 +
              extraReward.reward_amount_3 * 1
            );
        }
        return 0;
    },
    getExtraRewardName(salesmanId, which) {
        const extraReward = this.getExtraReward(salesmanId);
        if (extraReward) {
            if (which) {
              if (which == 1) {
                return extraReward.reward_name;
              }
              return extraReward[`reward_name_${which}`];
            }
            return (
              extraReward.reward_name + (extraReward.reward_name_2 ? ' / ' : '') +
              extraReward.reward_name_2 + (extraReward.reward_name_3 ? ' / ' : '') +
              extraReward.reward_name_3
            );
        }
        return '';
    },
    getCommissionRuleText(salesmanId) {
        const extraReward = this.getExtraReward(salesmanId);
        if (extraReward) {
            return extraReward.commission_rule_text.replaceAll('\r\n','<br>').replaceAll('\n','<br>');
        }
        return '';
    },
    getExtraRewardTotal(items) {
        const self = this;
        return items.reduce((total, item) => total + self.getExtraRewardAmount(item.profile == 'supervisor' ? item.supervisorId : item.salesmanId), 0);
    },
    hasPastChargeback(items) {
        for (let i=0; i<items.length; i++) {
            if (this.getPastChargebackAmount(items[i].profile == 'supervisor' ? items[i].supervisorId : items[i].salesmanId) > 0) {
                return true;
            }
        }
        return false;
    },
    getPastChargebackName(salesmanId) {
        const extraReward = this.getExtraReward(salesmanId);
        if (extraReward) {
            return extraReward.chargeback_name;
        }
        return '';
    },
    getPastChargebackAmount(salesmanId) {
        const extraReward = this.getExtraReward(salesmanId);
        if (extraReward) {
            return extraReward.chargeback_amount * 1;
        }
        return 0;
    },
    getPastChargebackTotal(items) {
        const self = this;
        return items.reduce((total, item) => total + self.getPastChargebackAmount(item.profile == 'supervisor' ? item.supervisorId : item.salesmanId), 0);
    },
    close() {
      window.opener.focus();
      window.close();
    },
    async pdf() {
      var self = this;

      self.$root.$emit("onLoading");

      const response = self.$store.dispatch(
        "reports/analyticalCommissionByProfilesDownloadInPdf",
        self.form
      )

      response.then(function(_downloadPdf) {
          let filename = 'analytical-commissions-by-profile.pdf'
          let blob = new Blob([_downloadPdf], {type: 'application/pdf'});

          let link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = filename
          link.click();

          self.$root.$emit("onLoading")
      });

      response.catch(function() {
        self.$root.$emit("onLoading");
      });
    },
    async getData() {
      var self = this;

      self.$root.$emit("onLoading");
      const response = self.$store.dispatch(
        "reports/analyticalCommissionByProfiles",
        self.form
      );

      response.then(function(_dataReports) {
        self.$root.$emit("onLoading");
      });

      response.catch(function() {
        self.$root.$emit("onLoading");
      });
    },
    async getDataAdministrators() {
      var self = this;

      self.$root.$emit("onLoading");

      const response = self.$store.dispatch("administrators/all");

      response.then(function(_administrators) {
        var administrator = _administrators.find(
          administrator => administrator.id === self.form.administrator_id
        );
        if (administrator !== undefined) {
          self.administrator = administrator.name;
        }
        self.$root.$emit("onLoading");
        self.getDataTeams();
      });

      response.catch(function() {
        self.$root.$emit("onLoading");
        self.getDataTeams();
      });
    },

    async getDataTeams() {
      var self = this;

      self.$root.$emit("onLoading");

      const response = self.$store.dispatch("teams/all");

      response.then(function(_teams) {
        var team = _teams.find(team => team.id === self.form.team_id);
        if (team !== undefined) {
          self.team = team.name;
        }
        self.$root.$emit("onLoading");
        self.getExtraRewards();
      });

      response.catch(function() {
        self.$root.$emit("onLoading");
        self.getExtraRewards();
      });
    },
    async getExtraRewards() {
      const self = this;
      self.extra_rewards = await ExtraRewards.query({
          date_start: Vue.moment(self.init_at).format('YYYY-MM-DD'),
          date_end: Vue.moment(self.end_at).format('YYYY-MM-DD'),
      });
      self.getConfiguration();
    },
    async getConfiguration() {
      const self = this;
      const response = await self.$store.dispatch("configurations/all");
      self.getData();
    },
    print() {
      window.print();
    },
    excel() {
      var nome = "RELATÓRIO DE COMISSÃO ANALÍTICA POR PERFIL";
      var htmlPlanilha =
        '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>' +
        nome +
        "</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--><title>" +
        nome +
        "</title></head><body><table>" +
        document.getElementById("conteudo").innerHTML +
        "</table>";
      var htmlBase64 = btoa(htmlPlanilha);
      var link = "data:application/vnd.ms-excel;base64," + htmlBase64;
      var hyperlink = document.createElement("a");
      hyperlink.download = "Relatório de Comissão Analítica por Perfil";
      hyperlink.href = link;
      hyperlink.style.display = "none";
      document.body.appendChild(hyperlink);
      hyperlink.click();
      document.body.removeChild(hyperlink);
    }
  },
  mounted() {
    var self = this;

    self.form = JSON.parse(self.$route.query.form);

    self.getDataAdministrators();

    self.date = self.dates.find(date => date.id === self.form.date_by).name;

    self.init_at = self.form.date_at[0];

    self.end_at = self.form.date_at[1];
  }
};
</script>
<style type="scss">
@media print {
  .dont-print {
    display: none;
  }
  .table .thead-dark th {
    color: #aaaaaa;
  }
  .table {
    width: 90%;
    margin: 5%;
  }
}
.panel-danger {
  border-color: #ebccd1;
  width: 93%;
  margin-left: 4%;
}
.panel-primary {
  border-color: #2ba5ff !important;
}
</style>